export function nightBusStep(t: any) {
  return [
    { icon: t("nightBusStep.0.icon"), text: t("nightBusStep.0.text") },
    { icon: t("nightBusStep.1.icon"), text: t("nightBusStep.1.text") },
    { icon: t("nightBusStep.2.icon"), text: t("nightBusStep.2.text") },
    { icon: t("nightBusStep.3.icon"), text: t("nightBusStep.3.text") },
  ];
}

export function getLiteralsPageLanguage(t: any) {
  return {
    title: t("literalsPageLanguage.title"),
    desc: t("literalsPageLanguage.desc"),
    required: t("literalsPageLanguage.required"),
    continueButton: t("literalsPageLanguage.continueButton"),
    back: t("literalsPageLanguage.back"),
  };
}

export function getLiteralsDateLanguage(t: any) {
  return {
    title: t("literalsDateLanguage.title"),
    desc: t("literalsDateLanguage.desc"),
    required: t("literalsDateLanguage.required"),
    continueButton: t("literalsDateLanguage.continueButton"),
    back: t("literalsDateLanguage.back"),
    label: t("literalsDateLanguage.label"),
  };
}

export function getResumenLiterals(t: any) {
  return {
    title: t("literalsResumen.title"),
    aboutPayment: t("literalsResumen.aboutPayment"),
    tcTitle: t("literalsResumen.tcTitle"),
    tcAccept: t("literalsResumen.tcAccept"),
    totalTravel: t("literalsResumen.totalTravel"),
    desgloseModal: {
      title: t("literalsResumen.desgloseModal.title"),
      altCloseModal: t("literalsResumen.desgloseModal.altCloseModal"),
      totalActivity: t("literalsResumen.desgloseModal.totalActivity"),
    },
  };
}

export function getTmbLenguageModal(t: any) {
  return {
    title: t("tmbLenguageModal.title"),
    description: t("tmbLenguageModal.description"),
    buttons: [
      {
        text: t("tmbLenguageModal.buttons.0.text"),
      },
    ],
  };
}

export function literalDetailTmb(t: any) {
  return {
    buttonBuy: t("literalDetailTmb.buttonBuy"),
    buttonOld: t("literalDetailTmb.buttonOld"),
    hideDetail: t("literalDetailTmb.hideDetail"),
    showDetail: t("literalDetailTmb.showDetail"),
    errorTitle: t("literalDetailTmb.errorTitle"),
    errorDesc: t("literalDetailTmb.errorDesc"),
    buttonError: t("literalDetailTmb.buttonError"),
    city: t("literalDetailTmb.city"),
  };
}

/**
 * Convertimos la hora en formato Zulú
 * @param date
 * @param time
 * @returns
 */
export function formatDate(date: Date, time: string) {
  let yourDate = new Date(date);
  let dateActual = new Date();
  if (dateActual.getDay() === yourDate.getDay()) {
    yourDate.setDate(yourDate.getDate());
  } else {
    yourDate.setDate(yourDate.getDate() + 1);
  }
  return `${yourDate.toISOString().split("T")[0] + "T" + time}:00Z`;
}

export function mappedSessions(availability: any, t: any) {
  let result = availability.map((item: any, index: any) => {
    return {
      id: index,
      title: item.language.map((o: any) => mappedLanguage(o, t)).join(" "),
      time: mappedTime(item.serviceDate),
      idTitle: item.language.map((o: any) => mappedLanguageId(o, t)),
      noMapped: item.language,
      serviceDate: item.serviceDate,
      // totalAvailability:item.totalAvailability
      totalAvailability: {
        text:item.totalAvailability===0 ? t("literalsResumen.complete"): item.totalAvailability+t("literalsResumen.available"),
        color: mappedAvailability(item.totalAvailability),
        backgroundcolor: "#FFFFFF",
        bordercolor: mappedAvailability(item.totalAvailability),
        number:item.totalAvailability
      },
    };
  });
  return result;
}

export function mappedLanguageId(key: String, t: any) {
  let idTitle = "";

  switch (key) {
    case "ES":
    case "es":
      idTitle = "ESP";
      break;
    case "EN":
    case "en":
      idTitle = "ENG";
      break;
    case "CA":
    case "ca":
      idTitle = "CAT";
      break;
    case "FR":
    case "fr":
      idTitle = "FRA";
      break;
    case "GL":
    case "gl":
      idTitle = "GAL";
      break;
    case "EU":
    case "eu":
      idTitle = "EUQ";
      break;
    case "VA":
    case "va":
      idTitle = "VAL";
      break;

    default:
      break;
  }

  return idTitle;
}

export function mappedLanguage(key: String, t: any) {
  let traslate = "";

  switch (key) {
    case "es":
      traslate = t("getLanguageMappingSessions.spain");
      break;
    case "en":
      traslate = t("getLanguageMappingSessions.english");
      break;
    case "ca":
      traslate = t("getLanguageMappingSessions.catalan");
      break;
    case "fr":
      traslate = t("getLanguageMappingSessions.french");
      break;
    case "gl":
      traslate = t("getLanguageMappingSessions.galician");
      break;
    case "eu":
      traslate = t("getLanguageMappingSessions.basque");
      break;
    case "va":
      traslate = t("getLanguageMappingSessions.valencian");
      break;

    default:
      break;
  }

  return traslate;
}

export function mappedTime(date: any) {
  let dateAux = new Date(date);

  let hourAux =
    dateAux.getHours() > 9
      ? dateAux.getHours().toString()
      : "0" + dateAux.getHours().toString();
  let minuteAux =
    dateAux.getMinutes() > 9
      ? dateAux.getMinutes().toString()
      : "0" + dateAux.getMinutes().toString();
  return hourAux + ":" + minuteAux;
}

export function mappedAvailability(number: any) {
  let color=""
  if ( number>= 6) {
    color= "#297570";
  }
  if (Number(number) <= 5) {
    color= "#B38900";
  }

  if (number === 0) {
    color= "#D04900";
  }
  return color;
}
